export default "__VITE_ASSET__ec82defa__"